<template>
  <header>
    <b-navbar toggleable="xl" fixed="top">
      <b-navbar-brand href="#">
        <router-link to="/">
          <img src="../assets/vcmi_logo.png" alt="VCMI's Logo" />
        </router-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse">
        <font-awesome icon="bars" />
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav id="paths">
            <b-nav-item><router-link class="nav-route" to="/">Home</router-link></b-nav-item>
            <b-nav-item><router-link class="nav-route" to="/members">Members</router-link></b-nav-item>
            <b-nav-item><router-link class="nav-route" to="/projects">Projects</router-link></b-nav-item>
            <b-nav-item><router-link class="nav-route" to="/publications">Publications</router-link></b-nav-item>
            <b-nav-item><router-link class="nav-route" to="/partners">Partners</router-link></b-nav-item>
            <b-nav-item><router-link class="nav-route" to="/news">News</router-link></b-nav-item>
            <b-nav-item><router-link class="nav-route" to="/events">Events</router-link></b-nav-item>
            <b-nav-item><router-link class="nav-route" to="/software">Software</router-link></b-nav-item>
            <b-nav-item><router-link class="nav-route" to="/about-us">About Us</router-link></b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>

export default {
  name: "Navigation",
  data() {
    return {
      pages: null
    };
  },
  methods: {
    handleScroll() {
      let header = document.querySelector(".navbar");
      if (window.scrollY > 0) header.classList.add("active");
      else header.classList.remove("active");
    },
    updatePath() {
      setTimeout(() => {
        let paths = document.getElementsByClassName('nav-route');
        for(let i=paths.length-1; i>=0; i--) {
          if(paths[i].classList.contains('router-link-active')) {
              paths[i].className += ' active-link';
              break;
          }
        }
      }, 500)
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("DOMContentLoaded", function(event){
      this.updatePath();
    }.bind(this), false);
  },
  watch: {
    '$route.path': 'updatePath'
  }
};
</script>

<style lang="scss">
header {
  .navbar {
    padding: 0.2em 5em;
    background-color: white !important;
    img {
      max-height: 70px;
    }
    &.active {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    }
    @include media-breakpoint-down(md) {
      padding: 0.2em 1em;
    }
  }
  .nav-item {
    padding-left: 1em;
  }
  .nav-route {
    color: $primary-color !important;
    font-weight: 500 !important;
    text-transform: uppercase;
    font-size: 0.9em;
    transition: all 0.2s ease-in;
    padding-top: 1em;
    padding-bottom: 1em;
    &:hover {
      color: $secondary-color !important;
      text-decoration: none;
    }
  }
  .active-link {
    color: $secondary-color !important;
    text-decoration: none;
  }
  .navbar-toggler {
    font-size: 1.6em;
    * {
      color: $primary-color !important;
    }
  }
}
</style>